// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__91aDQ","image":"Header_image__EeudG","name":"Header_name__1ow8l","info":"Header_info__3gF86","infoRow":"Header_infoRow__7dimZ"};